import { SignalDoc } from "@megaron/docs-contracts";

export const uniqueSignalsByType = (signals: SignalDoc[]): SignalDoc[] => {
  const seenSignalTypes = new Set<string>();

  return signals.filter((signal) => {
    if (seenSignalTypes.has(signal.signalType)) return false;
    seenSignalTypes.add(signal.signalType);
    return true;
  });
};

export const isSignalTypeUnread = (signals: SignalDoc[], signalType: string): boolean =>
  signals.some((signal) => signal.signalType === signalType && !signal.isRead);
